import { Stack, TextField } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IPartnerContactFormValues } from "src/entities/partners/model/types";
import { PhoneField } from "src/shared/components";
import {
  messages,
  regexps,
  validatePhone,
} from "src/shared/utils/hookFormRules";

export const ContactInfo: FC = () => {
  const { control } = useFormContext<IPartnerContactFormValues>();

  return (
    <Stack spacing={5} sx={{ pt: 2 }}>
      <Controller
        control={control}
        name={"email"}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="E-mail"
            error={!!error}
            helperText={error?.message}
          />
        )}
        rules={{
          required: messages.required,
          validate(fieldValue, formValues) {
            if (!formValues.phone_main && !fieldValue) {
              return messages.phoneOrEmail;
            }
          },
          pattern: {
            value: regexps.emailRegexp,
            message: messages.email,
          },
        }}
      />

      <Controller
        control={control}
        name={`messengers.${0}.login`}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="Skype"
            error={!!error}
            helperText={error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name={"phone_main"}
        render={({
          field: { ref, onChange, ...field },
          fieldState: { error },
        }) => (
          <PhoneField
            inputRef={ref}
            {...field}
            label="Основной телефон"
            onChange={(_fieldValue, info) => {
              onChange(info);
            }}
            error={!!error}
            helperText={error?.message}
          />
        )}
        rules={{
          validate(fieldValue, formValues) {
            if (!formValues.email && !fieldValue) {
              return messages.phoneOrEmail;
            }

            return validatePhone(fieldValue);
          },
        }}
      />

      <Controller
        control={control}
        name={"phone_additional"}
        render={({
          field: { ref, onChange, ...field },
          fieldState: { error },
        }) => (
          <PhoneField
            inputRef={ref}
            onChange={(_fieldValue, info) => {
              onChange(info);
            }}
            {...field}
            label="Дополнительный телефон"
            error={!!error}
            helperText={error?.message}
          />
        )}
        rules={{
          validate: (fieldValue) => validatePhone(fieldValue),
        }}
      />
    </Stack>
  );
};
